"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateGroup = void 0;
const core_ui_1 = require("@sierralabs/core-ui");
function useUpdateGroup(id) {
    const { data, isLoading, error, patch } = (0, core_ui_1.useApiPatch)(`groups/${id}`);
    return {
        updatedGroup: data,
        isUpdating: isLoading,
        updateError: error,
        updateGroup: patch
    };
}
exports.useUpdateGroup = useUpdateGroup;
//# sourceMappingURL=useUpdateGroup.js.map